import styled from '@mui/material/styles/styled';
import Button from '@mui/material/Button';

const StyledButton = styled(Button)({
  color: '#fff',
  gap: '4px',
  marginLeft: '-10px'
});

export { StyledButton };